import React from 'react';
import Anchor from 'common-ui-components/dist/components/Atoms/Anchor';
import { ReactSVG } from 'react-svg';
import PropTypes from 'prop-types';
import { getLabelWithComponent } from '../../../utils/utils';
import './LinkAndLabel.scss';

const LinkAndLabel = ({ labelMessage, onClick, labelLink, iconUrl, linkUrl }) => {
  const result = getLabelWithComponent(labelMessage, [
    <Anchor
      className="link-and-label"
      elementLocator="link-and-label-anchor"
      aria-label={labelLink}
      to={linkUrl || '#'}
      {...{
        onClick: e => {
          e.preventDefault();
          onClick();
        },
      }}
    >
      <ReactSVG wrapper="span" src={iconUrl} />
      {labelLink}
    </Anchor>,
  ]);

  return (
    <>
      {result.map(item => {
        if (typeof item === 'string') {
          return <span key={item}>{item}</span>;
        }
        return item;
      })}
    </>
  );
};

LinkAndLabel.propTypes = {
  onClick: PropTypes.func,
  labelLink: PropTypes.string,
  labelMessage: PropTypes.string,
  iconUrl: PropTypes.string,
  linkUrl: PropTypes.string,
};
LinkAndLabel.defaultProps = {
  onClick: () => {
    /* default onClick handler */
  },
  labelLink: '',
  labelMessage: '',
  iconUrl: '',
  linkUrl: '',
};

export default LinkAndLabel;
